import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

export function validateNumber(c: FormControl) {
  return !isNaN(c.value) ? null : {
    validNumber: {
      valid: false
    }
  };
}

@Directive({
  selector: '[validNumber][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useValue: validateNumber, multi: true}
  ]
})
export class JbNumberValidator {
}



// WEBPACK FOOTER //
// ./src/app/form/validators/number.validator.ts